import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Copy, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';

export function AudioQrCard({ audioUrl }) {
  const [qrDataUrl, setQrDataUrl] = useState('');

  useEffect(() => {
    let active = true;
    if (!audioUrl) {
      setQrDataUrl('');
      return () => {
        active = false;
      };
    }

    QRCode.toDataURL(audioUrl, {
      width: 220,
      margin: 2,
      color: {
        dark: '#111827',
        light: '#ffffff',
      },
    }).then((dataUrl) => {
      if (active) setQrDataUrl(dataUrl);
    }).catch(() => {
      if (active) setQrDataUrl('');
    });

    return () => {
      active = false;
    };
  }, [audioUrl]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(audioUrl);
      toast.success('Link copiado');
    } catch (error) {
      toast.error('No se pudo copiar el link');
    }
  };

  if (!audioUrl) return null;

  return (
    <Card className="border-cyan-200 bg-cyan-50/60 dark:bg-cyan-950/20 dark:border-cyan-900">
      <CardHeader>
        <CardTitle className="text-base">Abrir desde el celular</CardTitle>
        <CardDescription>
          Escaneá el QR o copiá el link para grabar desde otro dispositivo.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col sm:flex-row items-center gap-4">
        <div className="w-[220px] h-[220px] bg-white rounded-md border flex items-center justify-center">
          {qrDataUrl ? (
            <img src={qrDataUrl} alt="QR para grabar audio" className="w-[210px] h-[210px]" />
          ) : (
            <span className="text-sm text-muted-foreground">Generando QR...</span>
          )}
        </div>
        <div className="flex-1 min-w-0 space-y-3">
          <div className="text-xs bg-white/80 dark:bg-background rounded border p-2 break-all">
            {audioUrl}
          </div>
          <div className="flex flex-wrap gap-2">
            <Button type="button" variant="outline" onClick={handleCopy}>
              <Copy className="w-4 h-4 mr-2" />
              Copiar link
            </Button>
            <Button type="button" asChild>
              <a href={audioUrl} target="_blank" rel="noreferrer">
                <ExternalLink className="w-4 h-4 mr-2" />
                Abrir
              </a>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default AudioQrCard;
